function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formOptions from '../mixins/index.js';
import myMixins from '../mixins/method.js';
import { saveCard as _saveCard, jobsCreate, enterpriseCardIdApi, putCardApi, enterpriseWorkCreateApi, enterpriseEducationCreateApi, getWorkList as _getWorkList, getEducationList as _getEducationList } from '@/api/enterprise';
import { getResume as _getResume, saveResume as _saveResume, userCreateWork, userCreateEducation, getUserWorkList as _getUserWorkList, getUserEducationList as _getUserEducationList } from '@/api/user';
export default {
  name: 'formOptions',
  mixins: [formOptions, myMixins],
  props: {
    componentStatus: {
      type: Object,
      default: function _default() {}
    },
    user: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    id: {
      type: [String, Number, Boolean],
      default: function _default() {
        return false;
      }
    },
    tabtypes: {
      type: [String, Number, Boolean],
      default: 1
    },
    photo: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      departmentShow: false,
      memberShow: false,
      userWorkId: '',
      add: 'work',
      choiceEdit: 0,
      isEdit: 0,
      edit: 'edit',
      editTable: '新增',
      superiorUser: [],
      frames: [],
      treeData: [],
      setIndex: 0,
      superiorFrame: [],
      // 上级部门
      propsPos: {
        value: 'id',
        label: 'name',
        multiple: false,
        checkStrictly: true
      },
      mastart_id: '',
      // 主部门,
      ruleForm: {
        name: '',
        // 员工姓名
        phone: '',
        // 手机号码
        photo: '',
        position: '',
        // 职位
        card_id: '',
        // 身份证号
        birthday: '',
        // 生日,
        age: '',
        sex: 0,
        // 性别: 0、未知；1、男；2、女；3、其他
        nation: '',
        // 民族
        education: '',
        // 学历
        acad: '',
        // 学位
        politic: '',
        // 政治面貌
        address: '',
        // 居住地
        native: '',
        // 籍贯
        marriage: '',
        // 婚姻状况:0、未婚；1、已婚；
        work_start: '',
        // 开始工作时间
        spare_name: '',
        // 紧急联系人
        spare_tel: '',
        // 紧急联系电话
        email: '',
        // 邮箱
        sort: 0,
        // 排序
        invite: '',
        quit_time: '',
        // 离职时间
        status: '',
        // 状态：1、正常；0、锁定；
        is_admin: '0',
        // 负责人1=主管,0=普通成员
        work_years: '',
        // 工作年限
        work_time: '',
        // 入职时间
        trial_time: '',
        // 试用时间
        formal_time: '',
        // 转正时间
        treaty_time: '',
        // 合同到期时间
        frame_id: [],
        // 部门
        frames: [],
        graduate_name: '',
        // 毕业院校
        graduate_date: '',
        // 毕业时间
        card_front: '',
        // 身份证正面
        card_both: '',
        // 身份证反面
        education_image: '',
        // 学历证书
        acad_image: '',
        // 学位证书
        social_num: '',
        // 社保账号
        fund_num: '',
        // 公积金账号
        bank_num: '',
        // 银行卡
        bank_name: '',
        // 开户行
        main_id: '',
        // 组织架构主部门ID
        edit_type: '',
        type: 1,
        // 员工状态
        interview_date: '',
        // 面试时间
        interview_position: '',
        // 面试职位
        superior_uid: '',
        // 直属上级
        superior: {},
        // 身份证照片测试
        radio: '1'
        // 测试字段
      },
      rangeUser: [],
      tabsIndex: 'personalFile',
      direction: 'rtl',
      activeName: 'first',
      positionData: [],
      positionLabel: [],
      workData: [],
      rangeUserText: [],
      positionText: '',
      manage_frameText: '',
      is_adminText: '',
      superiorText: '',
      is_partText: '',
      typeText: '',
      marriageText: '',
      sexText: '',
      educationText: '',
      frameText: [],
      personId: 1,
      positionConfig: {},
      // 工作经历表格头部
      workLabel: [{
        name: this.$t('toptable.startdate'),
        prop: 'start_time',
        width: '100'
      }, {
        name: this.$t('toptable.endingdate'),
        prop: 'end_time',
        width: '100'
      }, {
        name: this.$t('hr.company'),
        prop: 'company',
        width: '110'
      }, {
        name: this.$t('hr.jobdescription'),
        prop: 'describe',
        width: '120'
      }, {
        name: this.$t('toptable.post'),
        prop: 'position',
        width: '100'
      }, {
        name: this.$t('hr.reasonsleaving'),
        prop: 'quit_reason',
        width: '120'
      }],
      // 教育经历
      educationsData: [],
      loading: false,
      // 教育经历表格头部
      educationLabel: [{
        name: this.$t('hr.admissiontime'),
        prop: 'start_time',
        width: '100'
      }, {
        name: this.$t('hr.graduationtime'),
        prop: 'end_time',
        width: '100'
      }, {
        name: this.$t('hr.schoolname'),
        prop: 'school_name',
        width: '90'
      }, {
        name: this.$t('hr.major'),
        prop: 'major',
        width: '90'
      }, {
        name: this.$t('hr.education'),
        prop: 'education',
        width: '80'
      }, {
        name: this.$t('hr.degree'),
        prop: 'academic',
        width: '80'
      }, {
        name: this.$t('public.remarks'),
        prop: 'remark',
        width: '100'
      }]
    };
  },
  mounted: function mounted() {
    this.getTreeData();
  },
  computed: {
    newFrom: function newFrom() {
      // 数据在minxins

      if (this.user == '个人简历') {
        return this.userForm;
      } else if (this.tabtypes === 0) {
        return this.notEntry;
      } else if (this.tabtypes === 2) {
        this.FORMOPTIONS.forEach(function (item) {
          if (item.title == '职工信息') {
            var obj = {
              type: 'date',
              label: '离职时间：',
              value: 'quit_time',
              placeholder: '请选择离职时间'
            };
            item.data.push(obj);
          }
        });
        return this.FORMOPTIONS;
      } else {
        this.FORMOPTIONS.forEach(function (item) {
          if (item.title == '职工信息') {
            if (item.data.length == 7) {
              item.data.splice(item.data.length - 1, 1);
            }
            item.data[1].optionsList.splice(2, 2);
          }
        });
        return this.FORMOPTIONS;
      }
    }
  },
  methods: {
    // 保存个人简历信息
    saveResume: function saveResume(val) {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.ruleForm.works = _this.workData;
          _this.ruleForm.photo = val;
          _this.ruleForm.frames = _this.rangeUser;
          _this.ruleForm.frame_id = _this.frames;
          _saveResume(_this.ruleForm).then(function (res) {
            _this.$emit('hiddenSave');
          }).catch(function (err) {
            _this.$emit('hiddenSave');
          });
        }
      });
    },
    // 身份证获取出生日期
    getBirthday: function getBirthday(val) {
      if (val !== 'card_id') return;
      var cardId = this.ruleForm.card_id;
      if (!cardId || cardId.length !== 15 && cardId.length !== 18) {
        this.ruleForm.birthday = '';
        this.ruleForm.sex = 0;
        this.ruleForm.age = '';
        return;
      }
      var birthday = '';
      var sex = '';
      if (cardId.length === 15) {
        birthday = '19' + cardId.substr(6, 6);
        sex = cardId.substring(14, 15);
      } else if (cardId.length === 18) {
        birthday = cardId.substr(6, 8);
        sex = cardId.substring(16, 17);
      }
      birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
      this.ruleForm.birthday = birthday;
      var birthDate = new Date(birthday);
      var currentDate = new Date();
      var age = currentDate.getFullYear() - birthDate.getFullYear() - (currentDate.getMonth() < birthDate.getMonth() || currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate() ? 1 : 0);
      this.ruleForm.sex = sex % 2 === 0 ? 2 : 1;
      this.ruleForm.age = isNaN(age) ? '' : age;
    },
    restFn: function restFn(data) {
      this.$refs.form.resetFields();
      this.FORMITEMISEDIT[data] = !this.FORMITEMISEDIT[data];
      this.enterpriseCardId();
    },
    // 默认值
    defaultFn: function defaultFn() {
      this.getDate();
      if (this.tabtypes == 0) {
        this.$set(this.ruleForm, 'type', '未入职');
      } else if (this.tabtypes == 1) {
        this.$set(this.ruleForm, 'type', 2);
      } else if (this.tabtypes == 2) {
        this.$set(this.ruleForm, 'type', 4);
        this.typeText = '离职';
      }
    },
    // 获取个人简历信息
    getResume: function getResume() {
      var _this2 = this;
      _getResume().then(function (res) {
        _this2.workData = res.data.works;
        _this2.educationsData = res.data.educations;
        res.data.education = Number(res.data.education);
        _this2.ruleForm = res.data;
        if (_this2.ruleForm.education == 0) {
          _this2.ruleForm.education = '';
        }
        _this2.userWorkId = res.data.id;
        if (_this2.ruleForm.card_id) {
          _this2.getBirthday();
        }
        _this2.$emit('getPhoto', res.data.photo);
      });
    },
    // 新增:保存个人档案信息
    saveCard: function saveCard() {
      var _this3 = this;
      this.ruleForm.works = this.workData;
      this.ruleForm.educations = this.educationsData;
      this.ruleForm.photo = this.photo;
      var position = '';
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this3.ruleForm.position.length > 0) {
            position = _this3.ruleForm.position[0];
          }
          _saveCard(_this3.tabtypes, _objectSpread(_objectSpread({}, _this3.ruleForm), {}, {
            position: position
          })).then(function (res) {
            _this3.$emit('submitOk');
            _this3.resetForm();
          });
        }
      });
    },
    // 编辑: 保存个人档案信息
    formItemEdit: function formItemEdit(type, itemIndex) {
      var _this4 = this;
      var valiSome = ['interview_position', 'interview_date', 'is_part', 'type'];
      var basicSome = ['name', 'phone', 'position', 'frame_id'];
      var flag = true;
      if (type == 'staff') {
        valiSome.forEach(function (item) {
          _this4.$refs.form.validateField(item, function (valid) {
            if (valid.length) {
              return flag = false;
            }
          });
        });
        if (flag) {
          this.editFn(type, itemIndex);
        }
      } else if (type == 'basic') {
        basicSome.forEach(function (item) {
          _this4.$refs.form.validateField(item, function (valid) {
            if (valid.length) {
              return flag = false;
            }
          });
        });
        if (flag) {
          this.editFn(type, itemIndex);
        }
      } else if (type == 'user') {
        this.$refs.form.validateField('card_id', function (valid) {
          if (!valid) {
            _this4.editFn(type, itemIndex);
          }
        });
      } else {
        this.editFn(type, itemIndex);
      }
    },
    editFn: function editFn(type, itemIndex) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this5.FORMITEMISEDIT[itemIndex] = !_this5.FORMITEMISEDIT[itemIndex];
              _this5.ruleForm.edit_type = type;
              if (_this5.ruleForm.position.length > 0) {
                _this5.ruleForm.position = _this5.ruleForm.position[_this5.ruleForm.position.length - 1];
              }
              _this5.ruleForm.frames = [];
              _this5.ruleForm.photo = _this5.photo;
              _this5.rangeUser.forEach(function (item) {
                _this5.ruleForm.frames.push(item.id);
              });
              _context.next = 8;
              return putCardApi(_this5.id, _this5.ruleForm);
            case 8:
              _context.next = 10;
              return _this5.enterpriseCardId();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 新增：职位等级
    addQuick: function addQuick() {
      this.positionConfig = {
        title: '添加职位',
        width: '520px',
        data: this.treeData
      };
      this.$refs.positionDialog.handleOpen();
    },
    handleConfig: function handleConfig() {
      this.getTreeData();
    },
    // 新增: 获取工作/教育经历列表
    addWorkFn: function addWorkFn(data, val) {
      if (val == 'work') {
        if (this.editTable == '编辑') {
          this.workData.splice(this.setIndex, 1, data);
        } else {
          this.workData.push(data);
        }
      } else {
        if (this.editTable == '编辑') {
          this.educationsData.splice(this.setIndex, 1, data);
        } else {
          this.educationsData.push(data);
        }
      }
    },
    // 刷新个人简历工作经历列表
    getUserWorkList: function getUserWorkList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                resume_id: _this6.userWorkId
              };
              _context2.next = 3;
              return _getUserWorkList(data);
            case 3:
              result = _context2.sent;
              _this6.workData = result.data.list;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 刷新个人简历教育经历列表
    getUserEducationList: function getUserEducationList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getUserEducationList();
            case 2:
              result = _context3.sent;
              _this7.educationsData = result.data.list;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 新增: 编辑工作/教育经历
    putWork: function putWork(row, index, type) {
      var _this8 = this;
      this.setIndex = index;
      this.editTable = '编辑';
      if (type === 'works') {
        this.$refs.refwork.title = '编辑工作经历';
        this.add = 'work';
        this.$nextTick(function () {
          _this8.$refs.refwork.workForm = row;
        });
      } else {
        this.$refs.refwork.title = '编辑教育经历';
        this.add = 'education';
        this.$nextTick(function () {
          _this8.$refs.refwork.educationForm = row;
        });
      }
      this.$refs.refwork.dialogFormVisible = true;
    },
    // 新增：删除工作/教育经历
    deleteWork: function deleteWork(row, index, type) {
      if (type === 'works') {
        this.workData.splice(index, 1);
      }
      if (type === 'education') {
        this.educationsData.splice(index, 1);
      }
    },
    // 编辑: 获取工作经历列表
    getWorkList: function getWorkList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                user_id: _this9.id
              };
              _context4.next = 3;
              return _getWorkList(data);
            case 3:
              result = _context4.sent;
              _this9.workData = result.data.list;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    //  编辑: 新增工作经历
    addWorks: function addWorks(val) {
      var _this10 = this;
      if (val === '工作经历') {
        if (this.user === '个人简历') {
          this.$modalForm(userCreateWork({})).then(function (res) {
            _this10.getUserWorkList();
          });
        } else {
          this.add = 'work';
          this.editTable = '新增';
          this.$refs.refwork.title = '新增工作经历';
          this.$refs.refwork.workForm = {};
          this.$refs.refwork.dialogFormVisible = true;
        }
      }
      if (val === '教育经历') {
        if (this.user === '个人简历') {
          this.$modalForm(userCreateEducation({})).then(function (res) {
            _this10.getUserEducationList();
          });
        } else {
          this.add = 'education';
          this.$refs.refwork.educationForm = {};
          this.editTable = '新增';
          this.$refs.refwork.title = '新增教育经历';
          this.$refs.refwork.dialogFormVisible = true;
        }
      }
    },
    // 编辑: 编辑工作经历
    editWorks: function editWorks() {
      var _this11 = this;
      this.$modalForm(enterpriseWorkCreateApi({
        user_id: this.id
      })).then(function (res) {
        _this11.getWorkList();
      });
    },
    // 编辑: 获取教育经历列表
    getEducationList: function getEducationList() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                user_id: _this12.id
              };
              _context5.next = 3;
              return _getEducationList(data);
            case 3:
              result = _context5.sent;
              _this12.educationsData = result.data.list;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 编辑 新增教育经历
    editEducation: function editEducation() {
      var _this13 = this;
      this.$modalForm(enterpriseEducationCreateApi({
        user_id: this.id
      })).then(function (res) {
        _this13.getEducationList();
      });
    },
    // 获取职位tree数据
    getTreeData: function getTreeData() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var result;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return jobsCreate();
            case 2:
              result = _context6.sent;
              _this14.treeData = result.data.tree;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 选择部门回调
    changeMastart: function changeMastart(data) {
      var _this15 = this;
      this.frames = data;
      var frameIdArr = [];
      this.frames.forEach(function (item) {
        frameIdArr.push(item.id);
        _this15.ruleForm.frame_id = frameIdArr;
      });
      var preMastartId = this.mastart_id;
      this.frames.forEach(function (el) {
        if (el.is_mastart) {
          _this15.ruleForm.main_id = el.id;
          if (preMastartId) {
            _this15.superiorFrame = _this15.superiorFrame.map(function (i) {
              return i.id === preMastartId ? el : i;
            });
          } else {
            _this15.superiorFrame.push(el);
          }
        }
      });
    },
    // 添加负责人
    handlesuperiorOpen: function handlesuperiorOpen() {
      var _this16 = this;
      setTimeout(function () {
        _this16.$refs.selectMember[0].handlePopoverShow();
      }, 200);
    },
    // 选择人员回调
    getSelectList: function getSelectList(data) {
      this.superiorUser = data;
      this.ruleForm.superior = this.superiorUser[0];
      this.ruleForm.superior_uid = this.superiorUser[0].value;
    },
    // 删除管理范围
    cardTag: function cardTag(index, val) {
      this.rangeUser = this.rangeUser.filter(function (item) {
        return item.id != val.id;
      });
    },
    // 删除所在部门
    handleDeleteDep: function handleDeleteDep(index) {
      this.$refs["popover-".concat(index)][0].doClose();
      this.frames.splice(index, 1);
    },
    // 回显数据
    enterpriseCardId: function enterpriseCardId() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res, newFrame, newId, typeNew, userInfo, arr;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this17.superiorUser = [];
              _this17.rangeUser = [];
              _context7.next = 4;
              return enterpriseCardIdApi(_this17.id);
            case 4:
              res = _context7.sent;
              _this17.formatData(res);
              _this17.ruleForm = res.data;
              if (!_this17.ruleForm.age) {
                _this17.ruleForm.age = '';
              }
              if (!_this17.ruleForm.work_years) {
                _this17.ruleForm.work_years = '';
              }
              if (!_this17.tabtypes) {
                _this17.typeText = '未入职';
                _this17.ruleForm.type = 3;
              }
              newFrame = [];
              newId = [];
              _this17.positionText = [];
              _this17.manage_frameText = '';
              _this17.frameText = [];
              _this17.workData = res.data.works;
              _this17.educationsData = res.data.educations;
              _this17.ruleForm.frame_id = [];
              res.data.frames.map(function (item) {
                _this17.ruleForm.frame_id.push(item.id);
              });
              _this17.rangeUserText = [];
              typeNew = '';
              if (!_this17.tabtypes) {
                typeNew = '未入职';
              } else if (_this17.tabtypes === 1) {
                typeNew = '在职';
              } else {
                typeNew = '离职';
              }
              userInfo = {
                name: res.data.name,
                id: res.data.id,
                type: typeNew,
                uid: res.data.uid,
                position: res.data.job ? res.data.job.name : '暂无职位'
              };
              _this17.$emit('userInfoFn', userInfo);
              _this17.$emit('getPhoto', res.data.photo);
              _this17.frames = res.data.frames;
              _this17.frames.forEach(function (el) {
                if (el.is_mastart) {
                  _this17.ruleForm.main_id = el.id;
                  _this17.mastart_id = el.id;
                }
                var val = {
                  name: el.name,
                  is_mastart: el.is_mastart
                };
                newFrame.push(val);
                newId.push(el.id);
                _this17.frameText = newFrame;
              });
              _this17.rangeUser = res.data.scope;
              _this17.rangeUser.forEach(function (item, index) {
                _this17.rangeUserText.push(item.name);
              });
              res.data.education = Number(res.data.education);
              _this17.ruleForm.position = res.data.job ? res.data.job.id : '';
              _this17.positionText = res.data.job ? res.data.job.name : '';
              if (res.data.manage_frames.length > 0) {
                arr = [];
                res.data.manage_frames.map(function (item) {
                  arr.push(item.name);
                });
                _this17.manage_frameText = arr.join(',');
              } else {
                _this17.manage_frameText = '--';
              }
              _this17.is_adminText = res.data.is_admin === 1 ? '是' : '否';
              _this17.ruleForm.is_admin = res.data.is_admin + '';
              _this17.superiorText = res.data.superior ? res.data.superior.name : '';
              if (res.data.superior.length !== 0) {
                _this17.superiorUser.push(res.data.superior);
                _this17.ruleForm.superior_uid = _this17.superiorUser[0].id;
              } else {
                _this17.ruleForm.superior_uid = '';
              }
            case 37:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  },
  components: {
    // 新增: 添加工作/教育经历
    Addwork: function Addwork() {
      return import('./addWork');
    },
    // 编辑: 工作/教育经历
    tableBox: function tableBox() {
      return import('../components/tableBox');
    },
    // 上传图片
    UploadImage: function UploadImage() {
      return import('../src/UploadImage.vue');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    // 职位等级
    positionDialog: function positionDialog() {
      return import('@/views/hr/archives/components/positionDialog');
    }
  }
};